import { createContext, useContext } from "react"

export const SEOMetaContext = createContext({ updateSEOMeta: () => {} })

export const useSEOMeta = () => useContext(SEOMetaContext)
